define(["exports", "./utils", "./expose-modules", "text!../../worker/respec-worker.js"], function (_exports, _utils, _exposeModules, _respecWorker) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.worker = _exports.name = void 0;
  _respecWorker = _interopRequireDefault(_respecWorker);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check

  /**
   * Module core/worker
   *
   * Exports a Web Worker for ReSpec, allowing for
   * multi-threaded processing of things.
   */
  const name = "core/worker"; // Opportunistically preload syntax highlighter, which is used by the worker

  _exports.name = name;
  // Opportunistically preload syntax highlighter
  const hint = {
    hint: "preload",
    href: "https://www.w3.org/Tools/respec/respec-highlight.js",
    as: "script"
  };
  const link = (0, _utils.createResourceHint)(hint);
  document.head.appendChild(link);
  const workerURL = URL.createObjectURL(new Blob([_respecWorker.default], {
    type: "application/javascript"
  }));
  const worker = new Worker(workerURL);
  _exports.worker = worker;
  (0, _exposeModules.expose)(name, {
    worker
  });
});
//# sourceMappingURL=worker.js.map